if (!customElements.get('rb-subtotal')) {
  class RbSubtotal extends HTMLElement {
    connectedCallback() {
      this.valueEl = this.querySelector('[data-rb-subtotal-value]');
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.format = this.dataset.format || '{{amount}}';
      this.available = this.dataset.available !== 'false';
      this.form = this.closest('.product-form__quantity') || this.closest('.product__info-container') || this.parentElement;
      this.onChange = () => this.render();
      this.onClick = (event) => {
        if (event.target.closest('.quantity__button')) setTimeout(() => this.render(), 0);
      };
      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('click', this.onClick);
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            if (!data || (data.sectionId && data.sectionId !== this.dataset.section)) return;
            if (data.variant) {
              this.price = data.variant.price;
              this.available = data.variant.available !== false;
            } else {
              this.available = false;
            }
            this.render();
          });
        }
      } catch (error) {
        /* total still updates on quantity changes */
      }
      this.render();
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      if (this.form) {
        this.form.removeEventListener('input', this.onChange);
        this.form.removeEventListener('change', this.onChange);
        this.form.removeEventListener('click', this.onClick);
      }
    }

    quantity() {
      const input = document.getElementById('Quantity-' + this.dataset.section);
      const value = parseInt(input && input.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    money(cents) {
      const amount = cents / 100;
      const group = (number, decimals) => {
        const parts = number.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      };
      return this.format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
        if (key === 'amount_no_decimals') return group(Math.round(amount), 0);
        if (key === 'amount_with_comma_separator') return group(amount, 2).replace(/[,.]/g, (c) => (c === ',' ? '.' : ','));
        if (key === 'amount_no_decimals_with_comma_separator') return group(Math.round(amount), 0).replace(/,/g, '.');
        return group(amount, 2);
      });
    }

    render() {
      if (!this.valueEl) return;
      this.hidden = !this.available;
      this.valueEl.textContent = this.money(this.price * this.quantity());
    }
  }
  customElements.define('rb-subtotal', RbSubtotal);
}